const BASE_URL = "/receivable";


export default [
  {
    path: `${BASE_URL}`,
    name: "Receivable",
    component: () => import("@/pages/receivable/Index.vue"),
  },
  {
    path: `${BASE_URL}/setup`,
    name: "Receivable Setup",
    component: () => import("@/pages/receivable/salesReceivableSetup/Index.vue"),
  },
  {
    path: `${BASE_URL}/client`,
    name: "Client",
    component: () => import("@/pages/receivable/client/Index.vue"),
  },
  {
    path: `${BASE_URL}/cash-receipt-journal`,
    name: "Cash Receipt Journal",
    component: () => import("@/pages/receivable/cashReceiptJournal/Index.vue"),
  },
  {
    path: `${BASE_URL}/sales-invoice`,
    name: "Sales Invoice",
    component: () => import("@/pages/receivable/salesInvoice/Index.vue"),
  },
  {
    path: `${BASE_URL}/receivable-invoice`,
    name: "Receivable Invoice",
    component: () => import("@/pages/receivable/receivableInvoice/Index.vue"),
  },
  {
    path: `${BASE_URL}/sales-credit-memo/:id?`,
    name: "Sales Credit Memo",
    component: () => import("@/pages/receivable/salesCreditMemo/Index.vue"),
  },
  {
    path: `${BASE_URL}/invoice-email-log`,
    name: "Invoice Email Log",
    component: () => import("@/modules/sales_invoice/view/SendInvoicesEmailLogPage.vue"),
  },
];
